import React from 'react';
import { Download, FileText } from 'lucide-react';
import PropTypes from 'prop-types';

const ResultView = ({
  translatedFile,
  HOST,
  handleViewText,
  loadingText,
  showPdfViewer,
  setShowPdfViewer,
  textContent,
  setTextContent,
}) => (
  <div className="h-full flex items-center justify-center">
    <div className="mt-4 text-center text-gray-800 flex items-center justify-center">
      <div className="bg-white p-5 rounded-lg flex flex-col items-center justify-center w-full relative">
        <p className="text-xl mb-6">Download your translated documents</p>
        <div className="flex justify-center gap-4 flex-wrap">
          <a
            href={`${HOST}/download?file=${encodeURIComponent(translatedFile?.pdfPath)}`}
            target="_blank"
            rel="noreferrer"
            className="bg-pl_prim_color_1 text-white px-6 py-3 rounded-full hover:bg-pl_prim_color_2 flex items-center"
          >
            <Download size={18} className="mr-2" />
            Download PDF
          </a>
          <a
            href={`${HOST}/download?file=${encodeURIComponent(translatedFile?.docxPath)}`}
            target="_blank"
            rel="noreferrer"
            className="bg-pl_prim_color_1 text-white px-6 py-3 rounded-full hover:bg-pl_prim_color_2 flex items-center"
          >
            <Download size={18} className="mr-2" />
            Download DOCX
          </a>
          <button
            onClick={handleViewText}
            className="bg-pl_prim_color_1 text-pl_txt_dark_1 px-6 py-3 rounded-full hover:bg-pl_prim_color_2 flex items-center"
            disabled={loadingText}
          >
            <FileText size={18} className="mr-2" />
            {loadingText ? "Loading..." : "View Text"}
          </button>
        </div>
        {showPdfViewer && (
          <div className="mt-8 flex flex-col items-center">
            <button
              onClick={() => setShowPdfViewer(false)}
              className="mb-2 px-4 py-1 rounded bg-red-500 text-white hover:bg-red-600"
            >
              Close
            </button>
            <iframe
              src={`${HOST}/download?file=${encodeURIComponent(translatedFile?.pdfPath)}`}
              title="PDF Viewer"
              width="100%"
              height="450px"
              className="border rounded-lg shadow"
            />
          </div>
        )}
        {textContent && (
          <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 bg-gray-100 rounded-lg p-6 text-left w-11/12 max-w-4xl shadow-lg">
            <div className="flex justify-between items-center mb-2">
              <span className="font-semibold text-lg text-gray-700">Translated Text</span>
              <button
                onClick={() => setTextContent('')}
                className="text-red-500 hover:underline text-sm"
              >
                Close
              </button>
            </div>
            <pre 
              className="whitespace-pre-wrap text-gray-800 text-sm overflow-y-auto max-h-[40vh]"
              style={{
                fontFamily: "'Noto Sans Tamil', 'Noto Sans Sinhala', sans-serif",
                lineHeight: '1.6'
              }}
            >
              {textContent}
            </pre>
          </div>
        )}
      </div>
    </div>
  </div>
);

ResultView.propTypes = {
  translatedFile: PropTypes.shape({
    pdfPath: PropTypes.string,
    docxPath: PropTypes.string,
    textPath: PropTypes.string,
  }),
  HOST: PropTypes.string.isRequired,
  handleViewText: PropTypes.func.isRequired,
  loadingText: PropTypes.bool,
  showPdfViewer: PropTypes.bool,
  setShowPdfViewer: PropTypes.func.isRequired,
  textContent: PropTypes.string,
  setTextContent: PropTypes.func.isRequired,
};

export default ResultView; 